export class Environment {
    public static instance: Environment = new Environment();
    private _apiRoot: string;
    private _hostingRoot: string;

    constructor() {
        this._apiRoot = 'https://sandbox-api.paysimple.com';
        this._hostingRoot = 'https://sandbox-api.paysimple.com';
    }

     get apiRoot(): string {
        return this._apiRoot;
    }

    get hostingRoot(): string {
        return this._hostingRoot;
    }
}
